const CACHE_TIME = 1000 * 60 * 10;

// 10 minutos

export const guardarCache = (key, data) => {
  try {
    localStorage.setItem(
      key,
      JSON.stringify({
        timestamp: Date.now(),
        data,
      }),
    );
  } catch (error) {
    console.error("Error guardando cache:", error);
  }
};

export const leerCache = (key) => {
  try {
    const raw = localStorage.getItem(key);

    if (!raw) return null;

    const parsed = JSON.parse(raw);

    const expirado = Date.now() - parsed.timestamp > CACHE_TIME;

    if (expirado) {
      localStorage.removeItem(key);

      return null;
    }

    return parsed.data;
  } catch (error) {
    console.error("Error leyendo cache:", error);

    return null;
  }
};

export const limpiarCache = (key) => {
  localStorage.removeItem(key);
};
